import { createFileRoute, redirect } from "@tanstack/react-router";

/** Sammanslagen med elavtalssidan – permanent omdirigering. */
export const Route = createFileRoute("/elpriser/timpris")({
  beforeLoad: () => {
    throw redirect({ to: "/elavtal/timpris", statusCode: 301 });
  },
});
